import { Section } from '@layouts/Section/Section';
import { Container } from '@layouts/Container/Container';
import { Text } from '@acb_devel/design-system';
import { Link } from '@acb_devel/design-system';
import { BrandXIcon } from '@acb_devel/design-system';
import { BrandInstagramIcon } from '@acb_devel/design-system';
import { BrandTiktokIcon } from '@acb_devel/design-system';

import {
  INSTAGRAM,
  TWITTER,
  TIKTOK,
  EMAIL_CONTACT,
  LEGAL_NOTICE,
} from '@data/constants';

import styles from './Footer.module.scss';

export function Footer() {
  return (
    <Section as="footer" className={styles.footer}>
      <Container className={styles.footer__container}>
        <div className={styles.footer__firstBlockContainer}>
          <div className={styles.footer__social}>
            <Link
              href={TWITTER}
              target="_blank"
              unstyled
              aria-label="Twitter de Voluntarios acb"
            >
              <BrandXIcon width={24} height={24} />
            </Link>
            <Link
              href={INSTAGRAM}
              target="_blank"
              unstyled
              aria-label="Instagram de Voluntarios acb"
            >
              <BrandInstagramIcon width={24} height={24} />
            </Link>
            <Link
              href={TIKTOK}
              target="_blank"
              unstyled
              aria-label="Tiktok de Voluntarios acb"
            >
              <BrandTiktokIcon width={19} height={24} />
            </Link>
          </div>
          <Text variant="body-1">Copyright © acb.com, 2001-2024</Text>
        </div>
        <div className={styles.footer__items}>
          <Link
            href={`mailto:${EMAIL_CONTACT}`}
            target="_blank"
            unstyled
            className={styles.footer__item}
          >
            <Text variant="body-1" as="span">
              Contacto
            </Text>
          </Link>
          <Link
            href={LEGAL_NOTICE}
            target="_blank"
            unstyled
            className={styles.footer__item}
          >
            <Text variant="body-1" as="span">
              Aviso legal
            </Text>
          </Link>
          {/* <Link
            href="#"
            target="_blank"
            unstyled
            className={styles.footer__item}
          >
            <Text variant="body-1" as="span">
              Política de cookies
            </Text>
          </Link>
          <Link
            href="#"
            target="_blank"
            unstyled
            className={styles.footer__item}
          >
            <Text variant="body-1" as="span">
              Política de protección de datos
            </Text>
          </Link> */}
        </div>
      </Container>
    </Section>
  );
}
